import { api } from '../Configs/AxiosConfigs'
import { defineCancelApiObject } from '../Configs/AxiosUtils'

export const ProfileApis = {
  userForgotPassword: async function (username, password, cancel = false) {
    console.log(`/v1/user/forgotpassword`, api, password, username)
    const response = await api.request({
      url: `/v1/user/forgotpassword`,
      method: 'POST',
      headers: {},
      data: {
        username: username, // This is the body part
        password: password,
      },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  // getuserProfile: async function (profile, cancel = false) {
  //   console.log(`/v1/user/profile`, api)
  //   const response = await api.request({
  //     // url: `/v1/user/profile`,
  //     url: `/v1/profile/personalinfo/view`,
  //     method: 'POST',
  //     headers: {
  //       Authorization: `Bearer:${localStorage.getItem('Authorization')}`
  //     },
  //     data: profile,
  //     signal: cancel
  //       ? cancelApiObject[this.get.name].handleRequestCancellation().signal
  //       : undefined,
  //   })

  //   return response.data
  // },
  getUserDefaultProfileImages: async function (profile, cancel = false) {
    console.log(`/v1/profile/defaultimagesv2`, api)
    const response = await api.request({
      url: `/v1/profile/defaultimagesv2`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: profile,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  getUserPersonalDetailsByUserId: async function (profile, cancel = false) {
    console.log(`/v1/profile/personal/display/details/userid`, api)
    const response = await api.request({
      url: `/v1/profile/personal/display/details/userid`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: profile,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  getUserPersonalDetails: async function (profile, cancel = false) {
    console.log(`/v1/profile/personalinfo/view`, api)
    const response = await api.request({
      url: `/v1/profile/personalinfo/view`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: profile,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  getUserBusinessPersonalDetails: async function (profile, cancel = false) {
    console.log(`/v1/profile/personalinfo/view`, api)
    const response = await api.request({
      url: `/v1/businessprofile/businessinfo/view/userid`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: profile,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  getViewAllBusinessFeedBackByBusinessId: async function (profile, cancel = false) {
    console.log(`/v1/businessprofile/businessfeedback/viewall/businessid`, api)
    const response = await api.request({
      url: `/v1/businessprofile/businessfeedback/viewall/businessid`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: profile,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  updateuserProfile: async function (profile, cancel = false) {
    console.log(`/v1/user/profile`, api)
    const response = await api.request({
      url: `/v1/user/profile`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: profile,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  updateuserProfileForDriver: async function (profile, cancel = false) {
    // console.log(`/v1/user/profile/${type}`, api)
    const response = await api.request({
      url: `/v1/user/profile/personalinfo`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: profile,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  userVerifyUserName: async function (usernameObj, cancel = false) {
    console.log(`/v1/user/verifyUserName`, api)
    const response = await api.request({
      url: `/v1/user/verifyUserName`,
      method: 'POST',
      headers: {},
      data: usernameObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  // userVerifyUserName: async function (usernameObj, cancel = false) {
  //   console.log(`/v1/user/verifyUserName`, api);
  //   const response = await api.request({
  //     url: `/v1/user/verifyUserName`,
  //     method: "POST",
  //     headers: {},
  //     data: usernameObj,
  //     signal: cancel
  //       ? cancelApiObject[this.get.name].handleRequestCancellation().signal
  //       : undefined,
  //   });
  //   console.log("response", response);

  //   return response.data;
  // },
  userMobileStatus: async function (obj, cancel = false) {
    console.log(`/v1/user/mobile/status`, api)
    const response = await api.request({
      url: `/v1/user/mobile/status`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: obj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  userVerifyEmail: async function (emailObj, cancel = false) {
    console.log(`/v1/user/verifyEmail`, api)
    const response = await api.request({
      url: `/v1/user/verifyEmail`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: emailObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },

  userVerifyMobile: async function (mobileObj, cancel = false) {
    console.log(`/v1/user/verifyMobile`, api)
    const response = await api.request({
      url: `/v1/user/verifyMobile`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: mobileObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },

  userEmailStatus: async function (obj, cancel = false) {
    console.log(`/v1/user/email/status`, obj)
    const response = await api.request({
      url: `/v1/user/email/status`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: obj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  createProfileTag: async function (obj, cancel = false) {
    // console.log(`/v1/user/profile/profileTag/create`, api)
    const response = await api.request({
      url: `/v1/profile/personalprofile/personaltagline`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: obj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  // createProfileTag: async function (obj, cancel = false) {
  //   console.log(`/v1/user/profile/profileTag/create`, api)
  //   const response = await api.request({
  //     url: `/v1/user/profile/profileTag/create`,
  //     method: 'POST',
  //     headers: {
  //       Authorization: `Bearer:${localStorage.getItem('Authorization')}`
  //     },
  //     data: obj,
  //     signal: cancel
  //       ? cancelApiObject[this.get.name].handleRequestCancellation().signal
  //       : undefined,
  //   })
  //   return response.data
  // },
  viewProfileTag: async function (obj, cancel = false) {
    console.log(`/v1/user/profile/profileTag`, api)
    const response = await api.request({
      url: `/v1/profile/personalprofile/personaltagline/view/userid`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: obj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  updateProfileTag: async function (obj, cancel = false) {
    console.log(`/v1/user/profile/profileTag`, api)
    const response = await api.request({
      url: `/v1/profile/personalprofile/personaltagline`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: obj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  deleteProfileTag: async function (obj, cancel = false) {
    console.log(`/v1/user/profile/profileTag/delete`, api)
    const response = await api.request({
      url: `/v1/profile/personalprofile/personaltagline`,
      method: 'DELETE',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: obj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  // userProfileImage: async function (email, cancel = false) {
  //   console.log(`/v1/profile/image`, api);
  //   const response = await api.request({
  //     url: `/v1/profile/image`,
  //     method: "POST",
  //     headers: {},
  //     data: email,
  //     signal: cancel
  //       ? cancelApiObject[this.get.name].handleRequestCancellation().signal
  //       : undefined,
  //   });
  //   console.log("response", response);

  //   return response.data;
  // },
  userProfileImage: async function (email, cancel = false) {
    console.log(`/v1/profile/image`, api)
    const response = await api.request({
      // url: `/v1/profile/image`,
      url: `/v1/profile/imagev2/self`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: email,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  userBusinessProfileImage: async function (email, cancel = false) {
    console.log(`/v1/profile/image`, api)
    const response = await api.request({
      // url: `/v1/profile/image`,
      url: `/v1/profile/business/imagev2/self`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: email,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  buddyProfileImage: async function (userObj, cancel = false) {
    console.log(`/v1/profile/image/{userId}`, api)
    // let accesToken = {
    //   fre8ProAccessToken: userObj?.fre8ProAccessToken,
    //   clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    // }
    const response = await api.request({
      // url: `/v1/profile/image/${userObj.userId}`,
      url: `/v1/profile/imagev2/self`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  GetProfileIDByUserId: async function (userObj, cancel = false) {
    console.log(`/v1/profile/profileid/byuserid`, api)
    const response = await api.request({
      url: `/v1/profile/profileid/byuserid`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  GetProfileImageByUserId: async function (userObj, cancel = false) {
    console.log(`/v1/profile/imagev2/self`, api)
    const response = await api.request({
      url: `/v1/profile/imagev2/self`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: userObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  // userPassword: async function (email, cancel = false) {
  //   console.log(`/v1/user/password`, api);
  //   const response = await api.request({
  //     url: `/v1/user/password`,
  //     method: "PUT",
  //     headers: {},
  //     data: {
  //       email,
  //     },
  //     signal: cancel
  //       ? cancelApiObject[this.get.name].handleRequestCancellation().signal
  //       : undefined,
  //   });
  //   console.log("response", response);

  //   return response.data;
  // },
  userPassword: async function (email, cancel = false) {
    console.log(`/v1/user/password`, api)
    const response = await api.request({
      url: `/v1/user/password`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: {
        email,
      },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  userProfileUploadImage: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      // url: `/v1/profile/uploadImage`,
      url: `/v1/profile/uploadImageats3`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response?.data
  },
  uploadUserProfileImage: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      // url: `/v1/profile/uploadImage`,
      url: `/v1/profile/imagev2`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response?.data
  },
  uploadUserBusinessProfileImage: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      // url: `/v1/profile/uploadImage`,
      url: `/v1/profile/business/imagev2`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`,
        "Content-Type": "multipart/form-data"
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response?.data
  },
  getDefaultUserCoverPhoto: async function (coverPhotoObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/profile/default/coverphoto`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: coverPhotoObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response?.data
  },
  getUserCoverPhotoSelf: async function (coverPhotoObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/profile/coverphoto/self`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: coverPhotoObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response?.data
  },
  userCoverUploadImage: async function (uploadImgObj, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/profile/coverphoto`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: uploadImgObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response?.data
  },
  userVerifyResendMobileCode: async function (mobileObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/verify/resendMobileCode`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: mobileObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  userVerifyResendEmailCode: async function (emailObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/verify/resendEmailCode`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: emailObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  getProfilePersonalInformation: async function (token, cancel = false) {
    let accessToken = {
      fre8ProAccessToken: token,
    }
    const response = await api.request({
      url: `/v1/user/profile/personalinfo`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: accessToken,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  updateProfilePersonalInformation: async function (personalObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/profile/personalinfo`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  updateFleetOwnerUserProfile: async function (personalObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/profile/fo`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  //driver apis

  //Follow api
  //Send request to un follow.
  sendUserUnfollowRequest: async function (personalObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/unfollow/request/send`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  //Send request to follow.
  sendUserFollowRequest: async function (personalObj, cancel = false) {
    const response = await api.request({
      // url: `/v1/user/follow/request/send`,
      url: `/v1/follow/request/send`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  //Get all the user whom Logged in User Follows.
  getLoggedInUserFollowingList: async function (personalObj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/follow/other`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  getTargetUserFollowingList: async function (personalObj, cancel = false) {
    // let accessToken = {
    //   fre8ProAccessToken: personalObj?.fre8ProAccessToken,
    // }
    const response = await api.request({
      // url: `/v1/user/follow/other/${personalObj?.targetUserId}`,
      url: `/v1/following/view/paginated`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  getAllFollowingCount: async function (personalObj, cancel = false) {
    const response = await api.request({
      url: `/v1/following/view/count`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  updateProfileIntersets: async function (route, token, cancel = false) {
    const response = await api.request({
      url: `/v1/user/profile/meta/${route}`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: {
        fre8ProAccessToken: token,
      },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },

  //Get all the user who are buddies for Logged in User.\
  getLoggedInUserBuddiesList: async function (personalObj, cancel = false) {
    console.log('---personalObj------>', personalObj)
    const response = await api.request({
      // url: `/v1/buddy`,
      url: `/v1/buddy/view/paginated`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  //Get all the user who follow Logged in User.
  getLoggedInUserFollowersList: async function (personalObj, cancel = false) {
    const response = await api.request({
      // url: `/v1/user/follow/me`,
      url: `/v1/follower/view/paginated`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  getAllFollowerCount: async function (personalObj, cancel = false) {
    const response = await api.request({
      url: `/v1/follower/view/count`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  getTargetUserBuddiesList: async function (personalObj, cancel = false) {
    const response = await api.request({
      // url: `/v1/buddy/${personalObj?.targetUserId}`,
      url: `/v1/buddy/view/paginated`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  getTargetUserFollowersList: async function (personalObj, cancel = false) {
    // let accessToken = {
    //   fre8ProAccessToken: personalObj?.fre8ProAccessToken,
    // }
    const response = await api.request({
      // url: `/v1/user/follow/me/${personalObj?.targetUserId}`,
      url: `/v1/follower/view/paginated`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: personalObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  updateProfileCouch: async function (route, token, cancel = false) {
    const response = await api.request({
      url: `/v1/user/profile/couch/meta/${route}`,
      method: 'POST',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: {
        fre8ProAccessToken: token,
      },
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },

  userPersonalInfoEdit: async function (Obj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/profile/personalinfo`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: Obj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  userPasswordChanger: async function (Obj, cancel = false) {
    const response = await api.request({
      // url: `/v1/user/password`,
      url: `/v1/user/password/reset`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: Obj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })
    return response.data
  },
  userMobileUpdate: async function (obj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/mobile`,
      method: 'PUT',
      headers: {},
      data: obj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
  userEmailUpdate: async function (obj, cancel = false) {
    const response = await api.request({
      url: `/v1/user/email`,
      method: 'PUT',
      headers: {},
      data: obj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },


  viewMembershipPlans: async function (bodyObj, userId, cancel = false) {
    // let headerVal = { "content-type": "multipart/form-data" }
    const response = await api.request({
      url: `/v1/ms/plan/all/${userId}`,
      method: 'post',
      headers: {
        Authorization: `Bearer:${localStorage.getItem('Authorization')}`
      },
      data: bodyObj,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    return response.data
  },
}
// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(ProfileApis)
